import { z } from "zod";

export const LoginSchema = z.object({
  email: z.email({ error: "invalid email format" }),
  password: z.string().min(1, { error: "password is required" })
});

export type LoginInput = z.infer<typeof LoginSchema>;

export const RegisterSchema = z.object({
  name: z.string().min(1, { error: "name is required" }),
  email: z.email({ error: "invalid email format" }),
  password: z
    .string()
    .min(8, { error: "password must be at least 8 characters" })
});

export type RegisterInput = z.infer<typeof RegisterSchema>;

export const CreateUserSchema = z.object({
  name: z.string().min(1, { error: "name is required" }),
  email: z.email({ error: "invalid email format" }),
  password: z
    .string()
    .min(8, { error: "password must be at least 8 characters" }),
  role: z.enum(["USER", "MODERATOR", "ADMIN", "REVIEWER"])
});

export const UpdateUserSchema = CreateUserSchema.partial();

export const ChangePasswordSchema = z.object({
  oldPassword: z.string().min(1, { error: "old password is required" }),
  newPassword: z
    .string()
    .min(8, { error: "new password must be at least 8 characters" })
});

export type ChangePasswordInput = z.infer<typeof ChangePasswordSchema>;
